export default __webpack_public_path__ + "static/media/Cruel_sun.39d0523f.mp3";